<template>
  <div>
    <a
      @click="$router.push({ path:pathPage,   
        params:{
          url: mediaData.newsurl,
          title:title
        }, 
        query:{ msg_ID: mediaData.msg_ID, pool_ID:poolID }
        }) 
        newtest(mediaData)"
      :href="'/mediaContent?msg_ID=' + mediaData.msg_ID + '&pool_ID=' + poolID"
      :title="t(mediaData.newstitle)"        
    >
      <div class="card-container"> 
        <v-card
          class="card-hover"
          :elevation="cardHoverState ? 10 : 2"
          width="100%"
          @mouseover="cardHoverState=true"
          @mouseout="cardHoverState=false"
          style="position: relative;"
        >
          <div class="image-container">
            <v-img
              class="white--text align-end card-image"
              width="100%"
              :aspect-ratio="16/9"
              :src="imgErorr.state ? imgErorr.src : mediaData.img"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              alt="erorr"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-img
                    :src="imgErorr.src"
                    :width="screenWidth"
                    height="200px"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  ></v-img>
                </v-row>
              </template>
            </v-img>
          </div>
          <v-card-title>
            <span id="card-news-title">{{ t(mediaData.newstitle) }}</span>
          </v-card-title>
          <v-card-subtitle class="pb-0">{{ mediaData.newsdate }}</v-card-subtitle>

          <v-card-text class="text--primary">
            <div class="mediaContent">{{ t(mediaData.newcontent) }}</div>
          </v-card-text>

          <v-card-actions class="d-flex justify-end px-4 pb-4" style="width: 100%; position: absolute; bottom: 0;">
            <a
              @click="$router.push({
                name: 'iframeNews', 
                params: { url: mediaData.newsurl, title: title, previousPageUrl: previousPage }
              })"
            >
            </a>
          </v-card-actions>
          <div class="arrow-container">
            <i class="fa-solid fa-circle-chevron-right fa-2x arrow-icon"></i>
          </div>
        </v-card>
      </div>
    </a>
  </div>
</template>

<script>
import idLogo from "@/assets/img/id.png";



export default {
  props: ["mediaData", "title", "pathPage", "poolID"],
  mounted() {
    this.setWidth();
  },
  data() {
    return {
      cardHoverState: false,
      screenWidth: 600,
      imgErorr: {
        state: false,
        src: idLogo,
      },
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown; 
    },
  },
  methods: {
    newtest(mediaData) {
      var self = this;
      document.getElementById("pageTitle").innerHTML =
        self.$store.state.deptName + "-" + mediaData.newstitle;
    },
  },
};
</script>

<style scoped lang="scss">
.mediaContent {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-align: left;
  font-size: 14px; 
  line-height: 1.6; 
}

#card-news-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: justify;
  font-size: 16px; 
  line-height: 1.4; 
  font-weight: bold;
}

.card-container{
  margin: 5px;
}

.v-card {
  padding: 16px; 
  box-sizing: border-box;
  border: solid 2px #0056b3  !important;
  background-color: #fff;
  border-radius: 12px; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease; 
}

.v-card-title {
  padding: 0 16px 8px; 
}

.v-card-subtitle {
  padding-bottom: 8px; 
  font-size: 12px; 
  color: #757575; 
}

.v-card-actions {
  padding: 8px 16px;
}

.image-container {
  width: 100%; 
  aspect-ratio: 16/9; 
  overflow: hidden;
  border-radius: 12px; 
}

.v-card {
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background-color: #fff;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.v-card:hover {
  transform: translateY(-5px); 
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15); 
}

.card-hover {
  position: relative;
  overflow: hidden; 
  background: cover;
}

.card-image {
  transition: transform 0.7s ease-out;
  transform: scale(1);
  position: relative; 
  overflow: hidden;
  max-width: 100%;
}

.card-hover:hover .card-image {
  transform: scale(1.1); 
}

.card-hover:hover{
  #card-news-title {
    color: #0056b3; 
  }
  .arrow-icon {
    color:#0056b3
  }
}

.arrow-container {
  display: flex;
  justify-content: flex-end;  
}

.arrow-icon {
  bottom: 10px;  
  right: 20px;
  color: #757575;
}

@media (max-width: 768px) {
  .v-card:hover {
    transform: none; 
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
  }
  .card-hover:hover .card-image {
    transform: scale(1); 
  }
  .v-card {
    border: none !important; 
    box-shadow: none; 
  }
}
</style>